"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rutFormat;
function rutFormat(rut) {
  let clearRut = rut.toLocaleLowerCase().replace(/[^\dk]/g, '');
  if (clearRut.length > 1) {
    const lastDigit = clearRut.slice(-1);
    const formattedRut = clearRut.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    clearRut = "".concat(formattedRut, "-").concat(lastDigit);
  }
  return clearRut;
}